import { ProductFilterItem } from "./product_filter_item";

export const ProductFilter = (props) => {
  function disableFilteringButton() {
    if (Object.keys(props.activeFilters).length > 0) {
      let disabled = props.filterInProgress ? " disabled" : "";
      const cssClass = "button button-primary button-smaller" + disabled;

      return (
        <div className={cssClass} onClick={() => props.disableFiltering()}>
          Vypnout filtraci
        </div>
      );
    }
  }

  function productsCountInfo() {
    if (
      Object.keys(props.activeFilters).length > 0 &&
      !props.filterInProgress
    ) {
      return (
        "vyfiltrováno " +
        props.filteredProductsCount +
        " z celkových " +
        props.productsCount +
        " produktů"
      );
    } else {
      return "produktů: " + props.filteredProductsCount;
    }
  }

  function brandFilter() {
    return (
      <li>
        <ProductFilterItem
          item={["Značka", props.brands]}
          filter={props.filter}
          activeFilter={props.activeFilters["Značka"]}
          filterInProgress={props.filterInProgress}
        />
      </li>
    );
  }

  function categoriesFilter() {
    return (
      <li>
        <ProductFilterItem
          item={[
            "Kategorie",
            props.categories.map((category) => {
              return { name: category.name, content: category.id };
            }),
          ]}
          filter={props.filter}
          activeFilter={props.activeFilters["Kategorie"]}
          filterInProgress={props.filterInProgress}
        />
      </li>
    );
  }

  function extendedWarrantyFilter() {
    return (
      <li>
        <ProductFilterItem
          item={["Prodloužená záruka zdarma", ["ano", "ne"]]}
          filter={props.filter}
          activeFilter={props.activeFilters["Prodloužená záruka zdarma"]}
          filterInProgress={props.filterInProgress}
        />
      </li>
    );
  }

  const paramProperties = props.filterItems.map((item) => (
    <ProductFilterItem
      item={item}
      filter={props.filter}
      key={item[0] + item[1]}
      activeFilter={props.activeFilters[item[0]]}
      filterInProgress={props.filterInProgress}
    />
  ));

  return (
    <div
      className="filter"
      id="filter"
      style={{ backgroundColor: "#eff5f9", marginLeft: -1, paddingLeft: 4 }}
    >
      <div
        className="row filter-headline"
        style={props.stickCategorySelection ? { display: "none" } : null}
      >
        <div className="col-xs-8">
          <h4>Filtrace spotřebičů</h4>
        </div>
        <div
          className="col-xs-4"
          style={{ marginTop: 12, textAlign: "right", paddingRight: 25 }}
        >
          {productsCountInfo()}
        </div>
      </div>
      <ul style={{ display: "flex" }}>
        {brandFilter()}
        {props.categories.length > 1 ? categoriesFilter() : null}
        {extendedWarrantyFilter()}
        {paramProperties}
      </ul>
      {disableFilteringButton()}
    </div>
  );
};
